import VueGoogleMaps from 'vue-google-maps-community-fork'

export function setupGoogleMaps(app, store) {
  // TODO нужно отказаться от country?.code в полъзу CUR_LOCATION?.ALPHA2 везде
  const code = store.state?.IS_COUNTRY_GLOBAL
    ? store.state?.CUR_LOCATION?.CODE || 'EN'
    : store.state?.country?.code || 'EN'

  const checkoutOptions = app?.config?.globalProperties?.$checkoutOptions || {}
  const lang = checkoutOptions?.countryLang?.[code] || 'en'

  app.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyDXYZHz-821B34i1rRgRKfySI20niR33_8',
      libraries: 'places,geometry',
      language: lang,
      v: 'weekly',
      channel: 1,
    },
  })
}
